import { FACTION_LOCATIONS } from "@frontier/content/world-layout";
export interface MapLandmark {
  readonly id: string;
  readonly label: string;
  readonly asset: string;
  readonly x: number;
  readonly y: number;
  /** Maximum visual dimension in world units; these objects have no collision shape. */
  readonly size: number;
  /** Camera travel factor; visual dimensions are independent of depth. */
  readonly parallax: number;
  readonly tint?: number;
}

export const MAP_BACKGROUND_ASSET = "/assets/map/deep-space.jpg";

export const MAP_LANDMARKS: readonly MapLandmark[] = [
  {
    id: "irida",
    label: "Ирида",
    asset: "/assets/map/blue-planet.png",
    x: 900,
    y: 900,
    size: 430,
    parallax: 0.44,
  },
  {
    id: "aurora",
    label: "Аурора",
    asset: "/assets/map/ringed-giant.png",
    x: 9100,
    y: 280,
    size: 760,
    parallax: 0.44,
  },
  {
    id: "ochre",
    label: "Охра",
    asset: "/assets/map/ochre-giant.png",
    x: 3770,
    y: 1930,
    size: 620,
    parallax: 0.48,
  },
  {
    id: "dust-veil",
    label: "Пылевая завеса",
    asset: "/assets/map/dust-nebula.png",
    x: 9280,
    y: 1730,
    size: 780,
    parallax: 0.72,
  },
  {
    id: "atlas-wreck",
    label: "Остов «Атлас»",
    asset: "/assets/map/derelict.png",
    x: 5040,
    y: 1530,
    size: 350,
    parallax: 1,
  },
  ...FACTION_LOCATIONS.map((region) => ({
    id: `landmark:${region.id}`,
    label: region.name,
    asset:
      region.weather === "debris-field"
        ? "/assets/map/derelict.png"
        : region.weather === "ion-storm"
          ? "/assets/map/dust-nebula.png"
          : region.factionId === "helion"
            ? "/assets/map/ochre-giant.png"
            : region.factionId === "nomads"
              ? "/assets/map/ringed-giant.png"
              : "/assets/map/blue-planet.png",
    x: region.x + 2650,
    y: region.y + 1650,
    size: region.weather === "debris-field" ? 370 : 650,
    parallax:
      region.weather === "debris-field"
        ? 1
        : region.weather === "ion-storm"
          ? 0.72
          : 0.44,
  })),
];

export const MAP_ASTEROID_ASSETS: readonly string[] = [
  "/assets/map/asteroid-rock-a.png",
  "/assets/map/asteroid-rock-b.png",
  "/assets/map/asteroid-iron.png",
];
